const mixin = {
  methods: {
    showDetails (rowIndex) {
      const grid = this.$refs.grid

      if (grid.expandRow) {
        grid.expandRow(rowIndex)
      }
    },
    closeAllRows () {
      const grid = this.$refs.grid
      if (grid.closeAllRows) {
        grid.closeAllRows()
      }
    }
  }
}

export default mixin
